<template>
    <div id="page-administrator-details">
      <administrator-form
          v-model="model"
          ref="form"
          :loading="loading"
          card-title="Create Administrator"
      />
  
      <div class="vx-row">
        <div class="vx-col sm:w-1/2">
          <div class="mt-8 flex flex-wrap items-center justify-start">
            <vs-button
              @click="$router.push({ name: 'content-management.administrators.list' })"
              class="my-4"
            >
              Cancel
            </vs-button>
          </div>
        </div>
        <div class="vx-col sm:w-1/2">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button
              :disabled="loading"
              @click="create"
              class="my-4"
              color="light"
            >
              Create
            </vs-button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  
  import AdministratorForm from "@/views/pages/content-management/administrators/Form";
  import NotificationMixin from "@/components/mixins/NotificationMixin";
  
  export default {
    name: "AdministratorCreate",
    components: {
      AdministratorForm
    },
    mixins: [NotificationMixin],
    data() {
      return {
        model: {},
        loading: false,
      };
    },
    methods: {
      getParams() {
        const params = {
          ...this.model
        }
  
        const references = [
          'Contact_FK',
        ]
  
        references.forEach((ref) => params[ref] = this.getReferenceId(ref))
  
        return params;
      },
      getReferenceId(fieldName) {
        if (!this.model[fieldName]) {
          return null;
        }
  
        return this.model[fieldName].id || null;
      },
      async create() {
        if (!this.$refs.form.validate()) {
          this.notifyError('Not all required fields have been provided');
          return false;
        }
  
        // this.loading = true;
        const params = this.getParams();

        if (!params.applications || !Object.keys(params.applications).length) {
          this.notifyError('Please select at least one Application');
          return false;
        }
  
        console.log(params);
        //  return;
        try {
          const {data} = await this.$api.contentManagementAdministrators.create(params);
          this.notifySuccess('Administrator created');
          this.$router.back();
        } catch (e) {
          this.notifyError('Administrator failed to be created');
          console.error(e)
        } finally {
        }
      }
    },
  };
  </script>
  
  <style scoped>
  
  </style>
  
